import { gql } from "@apollo/client";

export const GET_LATEST_METER_TELEMETRY = gql`
  query (
    $search: String
    $state: [Int]
    $tower: [String]
    $first: Int
    $skip: Int
    $sortField: String
    $sortOrder: String
  ) {
    latestMeterTelemetries(
      search: $search
      state: $state
      tower: $tower
      first: $first
      skip: $skip
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        id
        channel
        client {
          id
          name
          surname
          clientId
          expiryDate
          balance
          channel
          whBalance
          energyTradingEnabled
        }
        mamps
        state
        timestamp
        volts
        watthrs
        watts
        tower {
          zonkeId
        }
      }
    }
  }
`;
